import { 
	GET_ALGOLIA_SEARCH_HC_PROVIDER, 
	GET_ALGOLIA_SEARCH_USERS 
} from '../types';

import { setAlgoliaSearchHcProviderData, setAlgoliaSearchUsers } from '../actions/appActions';
import algoliaDataSearch from '../../helper/algoliaDataSearch';

export const algoliaMiddleware = ({dispatch,getState}) => (next) => {
	return async (action) => {

		if(action.type === GET_ALGOLIA_SEARCH_HC_PROVIDER) {
			const state = getState();
			const patientsHcProvider = state.app.patientsHcProvider;

			const searchResult = await algoliaDataSearch(action.payload);
			
			searchResult.patients = searchResult.patients.filter((patient => (
				patientsHcProvider.includes(patient.userId)
			)));

			searchResult.documents = searchResult.documents
			.filter((document) => patientsHcProvider.includes(document.objectID))
			.map((item) => Object.keys(item).map((key) => item[key]))
			.map((item) => item.slice(0, -2))
			.flat(1);

			return dispatch(setAlgoliaSearchHcProviderData(searchResult));
		};

		if(action.type === GET_ALGOLIA_SEARCH_USERS) {
			const searchResult = await algoliaDataSearch(action.payload);
			
			return dispatch(setAlgoliaSearchUsers(searchResult));
		};

		return next(action);
	};
};
